import React, { FC, ReactNode } from 'react'
import './map.scss'

// interface
interface IProps {
  /** 文案提示 */
  msg?: ReactNode;
  /** 高度 */
  height?: string;
}

const Empty: FC<IProps> = ({ msg, height }) => {
  return (
    <div
      className='map-empty'
      style={{ height, 'minHeight': height }}
    >
      <div className='text'>{msg}</div>
    </div>
  )
}

export default Empty
